import { cn } from "@faire/react/tools/cn";
import React from "react";

export const BadgeBase: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => <div {...props} className={cn("fs-badge", className)} />;
